module.exports = __webpack_public_path__ + "static/img/endProduct.1531794.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/endProduct.png
// module id = nrhx
// module chunks = 1